<gipi-abstract-form id="dialogClient"
                    name="dialogClient"
                    [dialog]="true">
    <gipi-toolbar mat-dialog-title
                  id="toolbarDialogClient">
        Ficha do Cliente
    </gipi-toolbar>

    <div mat-dialog-content
         fxLayout="column"
         fxLayoutGap="16px">
        <div fxLayout="row"
             fxLayout.lt-md="column"
             fxLayoutAlign="start end"
             fxLayoutGap="16px">
            <itss-input label="CPF"
                        [(ngModel)]="client.cpf"
                        *ngIf="client.cpf"
                        mask="000.000.000-00"
                        [disabled]="true"
                        fxFlex="20"
                        fxFlex.lt-md="100">
            </itss-input>
            <itss-input label="CNPJ"
                        [(ngModel)]="client.cnpj"
                        *ngIf="client.cnpj"
                        mask="00.000.000/0000-00"
                        [disabled]="true"
                        fxFlex="20"
                        fxFlex.lt-md="100">
            </itss-input>
            <itss-input label="Cliente"
                        [(ngModel)]="client.name"
                        [disabled]="true"
                        fxFlex
                        fxFlex.lt-md="100">
            </itss-input>
            <gipi-datepicker label="Cliente desde"
                             [(ngModel)]="client.createDate"
                             [disabled]="true"
                             fxFlex="20"
                             fxFlex.lt-md="100">
            </gipi-datepicker>
            <gipi-button label="Entrar em contato"
                         gipi-secondary
                         id="btnWhatsapp"
                         svgIcon="whatsapp"
                         (click)="whatsappContact()"
                         fxFlex="20"
                         fxFlex.lt-md="100">
            </gipi-button>
        </div>

        <div class="card-information card general-grid">
            <div fxFlex
                 fxLayout="column"
                 fxFlex.lt-md="100"
                 fxFlex.lt-sm="100">
                <div class="information">
                    <span> Bloqueado: </span>
                    <strong> {{ client.blocked ? 'Sim' : 'Não' }} </strong>
                </div>
                <div class="information">
                    <span> Compras: </span>
                    <strong> {{ client.shopping }} </strong>
                </div>
                <div class="information-row">
                    <div class="information">
                        <span>
                            Atraso médio (pendentes):
                            <mat-icon [matTooltip]="tooltipAverageDelay"
                                      matTooltipClass="mattooltip-line-break"
                                      class="information-help">
                                help
                            </mat-icon>
                        </span>
                        <strong> {{ client.averageDelay }} </strong>
                    </div>
                    <div class="information">
                        <span>
                            <!-- Histórico -->
                            Atraso médio:
                            <mat-icon [matTooltip]="tooltipAverageDelayLateInstallments"
                                      matTooltipClass="mattooltip-line-break"
                                      class="information-help">
                                help
                            </mat-icon>
                        </span>
                        <strong> {{ client.averageDelayLateInstallments }} </strong>
                    </div>
                </div>
                <div class="information">
                    <span> Saldo crédito/haver: </span>
                    <strong [style.color]="getColorByAmount(client.creditBalance)">
                        {{ client.creditBalance | currency:'BRL':'symbol':'1.2-2' }}
                    </strong>
                </div>
            </div>

            <div fxFlex
                 fxLayout="column"
                 fxFlex.lt-md="100"
                 fxFlex.lt-sm="100">
                <div class="information">
                    <span> Limite de promissória: </span>
                    <strong [style.color]="getColorByAmount(client.storeCreditLimit)">
                        {{ client.storeCreditLimit | currency:'BRL':'symbol':'1.2-2' }}
                    </strong>
                </div>
                <div class="information">
                    <span> Pendências promissória: </span>
                    <strong [style.color]="getColorByAmount(client.pendingStoreCredit)">
                        {{ client.pendingStoreCredit | currency:'BRL':'symbol':'1.2-2' }}
                    </strong>
                </div>
                <div class="information">
                    <span> Limite de crédito boleto: </span>
                    <strong [style.color]="getColorByAmount(client.billetCreditLimit)">
                        {{ client.billetCreditLimit | currency:'BRL':'symbol':'1.2-2' }}
                    </strong>
                </div>
                <div class="information">
                    <span> Pendências boleto: </span>
                    <strong [style.color]="getColorByAmount(client.pendingBillet)">
                        {{ client.pendingBillet | currency:'BRL':'symbol':'1.2-2' }}
                    </strong>
                </div>
            </div>

            <div fxFlex
                 fxLayout="column"
                 fxFlex.lt-md="100"
                 fxFlex.lt-sm="100">
                <div class="information">
                    <span> Nº de cheques: </span>
                    <strong> {{ client.numberChecks }} </strong>
                </div>
                <div class="information">
                    <span> Limite de crédito cheque: </span>
                    <strong [style.color]="getColorByAmount(client.creditCheckLimit)">
                        {{ client.creditCheckLimit | currency:'BRL':'symbol':'1.2-2' }}
                    </strong>
                </div>
                <div class="information">
                    <span> Cheques a depositar: </span>
                    <strong [style.color]="getColorByAmount(client.checksToDeposit)">
                        {{ client.checksToDeposit | currency:'BRL':'symbol':'1.2-2' }}
                    </strong>
                </div>
                <div class="information">
                    <span> Cheques devolvidos: </span>
                    <strong [style.color]="getColorByAmount(client.bouncedChecks)">
                        {{ client.bouncedChecks | currency:'BRL':'symbol':'1.2-2' }}
                    </strong>
                </div>
            </div>
        </div>

        <div class="card-information bill-grid"
             fxLayoutGap="16px"
             fxLayoutAlign="space-between stretch">
            <div class="card information bill-information"
                 fxFlex>
                <span> A receber atrasado: </span>
                <strong [style.color]="getColorByAmount(client.amountReceivableInOverdue)">
                    {{ client.amountReceivableInOverdue | currency:'BRL':'symbol':'1.2-2' }}
                </strong>
            </div>
            <div class="card information bill-information"
                 fxFlex>
                <span> A receber hoje: </span>
                <strong [style.color]="getColorByAmount(client.amountReceivable)">
                    {{ client.amountReceivableToday | currency:'BRL':'symbol':'1.2-2' }}
                </strong>
            </div>
            <div class="card information bill-information"
                 fxFlex>
                <span> Recebimentos futuros: </span>
                <strong [style.color]="getColorByAmount(client.amountReceivableToday)">
                    {{ client.amountReceivable | currency:'BRL':'symbol':'1.2-2' }}
                </strong>
            </div>
            <div class="card information bill-information"
                 fxFlex>
                <span> Total dos juros: </span>
                <strong [style.color]="getColorByAmount(client.totalInterest)">
                    {{ client.totalInterest | currency:'BRL':'symbol':'1.2-2' }}
                </strong>
            </div>
            <div class="card information bill-information"
                 fxFlex>
                <span> Total das multas: </span>
                <strong [style.color]="getColorByAmount(client.totalFine)">
                    {{ client.totalFine | currency:'BRL':'symbol':'1.2-2' }}
                </strong>
            </div>
            <div class="card information bill-information"
                 fxFlex>
                <span> Total a receber: </span>
                <strong [style.color]="getColorByAmount(client.totalAmountReceivable)">
                    {{ (totalAmountReceivable | async) }}
                </strong>
            </div>
        </div>

        <gipi-tab-group #tabGroup>
            <gipi-tab label="Vendas"
                      [disabled]="loading">
                <itss-table #table
                            [paginator]="true"
                            [showPageSizeOptions]="false"
                            [loading]="loading"
                            [columns]="columnsSale"
                            (page)="findSale($event)"
                            [paginatorLength]="pageSale.totalElements"
                            [paginatorPageIndex]="pageSale.number"
                            [data]="pageSale.content">
                </itss-table>
            </gipi-tab>
            <gipi-tab label="Extrato de contas"
                      [disabled]="loading"
                      (selectionChange)="findCardExtract()">
                <div fxLayout="row"
                     fxLayoutAlign="end center"
                     fxFlex
                     fxFlex.lt-md="100">
                    <gipi-button label="Exportar"
                                 gipi-tertiary
                                 id="btnExportDoc"
                                 #exportDocButton
                                 svgIcon="pdf"
                                 [disabled]="loading || (columnsClientStatement?.length <= 0)"
                                 fxFlex="10"
                                 fxFlex.lt-md="100"
                                 (click)="exportClientStatement()">
                    </gipi-button>
                </div>

                <itss-table #table
                            [paginator]="true"
                            [backendPagination]="false"
                            [showPageSizeOptions]="false"
                            [loading]="loading"
                            [paginatorPageSize]="5"
                            [paginatorLength]="columnsClientStatement?.length"
                            [columns]="columnsClientStatement"
                            [data]="clientStatementList">
                </itss-table>
            </gipi-tab>
        </gipi-tab-group>
    </div>

    <div mat-dialog-actions
         fxLayout="row"
         fxLayoutAlign="end center"
         fxLayoutGap="16px">
        <gipi-button label="Voltar"
                     gipi-secondary
                     id="btnReturn"
                     mat-dialog-close
                     fxFlex="20"
                     fxFlex.lt-md="100">
        </gipi-button>
    </div>
</gipi-abstract-form>

<ng-template #actions
             let-data>
    <itss-button tooltip="Dados da venda"
                 type="icon"
                 color="warn"
                 svgIcon="details"
                 (click)="navigateSaleData(data)">
    </itss-button>
</ng-template>